// import ux_svg from "../Images/ux-svg.svg";
// import React from "react";

interface UxSVGProps {
  classes: any;
}
export const UxSVG = ({ classes }: UxSVGProps) => {
  return (
    <div className={`${classes}`}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        viewBox="0 0 766.75 658.82"
      >
        <defs>
          <style>
            {`
                    .cls-1 {
                        isolation: isolate;
                    }
                    .cls-11, .cls-12, .cls-13, .cls-14, .cls-15, .cls-16, .cls-17, .cls-18, .cls-19, .cls-2, .cls-20, .cls-21, .cls-22, .cls-23, .cls-24, .cls-25, .cls-26, .cls-27, .cls-28, .cls-29, .cls-3, .cls-30, .cls-31, .cls-32, .cls-34, .cls-35, .cls-38, .cls-39, .cls-40, .cls-41, .cls-44, .cls-45, .cls-46, .cls-47, .cls-49, .cls-5, .cls-50, .cls-51, .cls-53, .cls-54, .cls-55, .cls-57, .cls-58, .cls-59, .cls-60, .cls-61, .cls-62, .cls-63, .cls-64, .cls-65, .cls-66, .cls-67, .cls-68, .cls-69, .cls-70, .cls-71, .cls-72, .cls-73, .cls-74, .cls-75, .cls-76, .cls-77, .cls-8 {
                        fill-rule: evenodd;
                    }
                    .cls-10, .cls-11, .cls-12, .cls-2, .cls-23, .cls-28, .cls-3, .cls-32, .cls-4, .cls-40, .cls-45, .cls-51, .cls-53, .cls-54, .cls-63, .cls-65, .cls-9 {
                        opacity: 0.5;
                    }
                    .cls-2 {
                        fill: url(#linear-gradient);
                    }
                    .cls-3 {
                        fill: url(#linear-gradient-2);
                    }
                    .cls-4 {
                        fill: url(#linear-gradient-3);
                    }
                    .cls-5 {
                        opacity: 0.25;
                        fill: url(#linear-gradient-4);
                    }
                    .cls-53, .cls-6 {
                        fill: #00638e;
                    }
                    .cls-7 {
                        fill: url(#linear-gradient-5);
                    }
                    .cls-33, .cls-47, .cls-48, .cls-8, .cls-9 {
                        fill: #fff;
                    }
                    .cls-10 {
                        fill: url(#linear-gradient-6);
                    }
                    .cls-11 {
                        fill: url(#linear-gradient-7);
                    }
                    .cls-12 {
                        fill: url(#linear-gradient-8);
                    }
                    .cls-13 {
                        fill: url(#linear-gradient-9);
                    }
                    .cls-14 {
                        fill: url(#linear-gradient-10);
                    }
                    .cls-15 {
                        fill: #ffa698;
                    }
                    .cls-16 {
                        fill: url(#linear-gradient-11);
                    }
                    .cls-17 {
                        fill: #22043d;
                    }
                    .cls-18 {
                        fill: url(#linear-gradient-12);
                    }
                    .cls-19 {
                        fill: #17acc8;
                    }
                    .cls-19, .cls-61 {
                        opacity: 0.35;
                    }
                    .cls-19, .cls-21, .cls-23, .cls-28, .cls-32, .cls-40, .cls-45, .cls-51, .cls-53, .cls-61, .cls-63, .cls-65 {
                        mix-blend-mode: multiply;
                    }
                    .cls-20 {
                        fill: url(#linear-gradient-13);
                    }
                    .cls-21 {
                        fill: #1e2353;
                        opacity: 0.3;
                    }
                    .cls-22 {
                        fill: url(#linear-gradient-14);
                    }
                    .cls-23 {
                        fill: url(#linear-gradient-15);
                    }
                    .cls-24 {
                        fill: url(#linear-gradient-16);
                    }
                    .cls-25 {
                        fill: url(#linear-gradient-17);
                    }
                    .cls-26 {
                        fill: url(#linear-gradient-18);
                    }
                    .cls-27 {
                        fill: #f3f8ff;
                    }
                    .cls-28 {
                        fill: #9fd2fb;
                    }
                    .cls-29 {
                        fill: url(#linear-gradient-19);
                    }
                    .cls-30 {
                        fill: url(#linear-gradient-20);
                    }
                    .cls-31 {
                        fill: url(#linear-gradient-21);
                    }
                    .cls-32 {
                        fill: url(#linear-gradient-22);
                    }
                    .cls-34, .cls-36 {
                        fill: #61addc;
                    }
                    .cls-35 {
                        fill: url(#linear-gradient-23);
                    }
                    .cls-37, .cls-47, .cls-48 {
                        opacity: 0.2;
                    }
                    .cls-37 {
                        fill: url(#linear-gradient-24);
                    }
                    .cls-38 {
                        fill: url(#linear-gradient-25);
                    }
                    .cls-39 {
                        fill: #ffc770;
                    }
                    .cls-40 {
                        fill: url(#linear-gradient-26);
                    }
                    .cls-41 {
                        fill: #6dad50;
                    }
                    .cls-42 {
                        fill: #f2f4ff;
                    }
                    .cls-43 {
                        fill: #dce8f8;
                    }
                    .cls-44 {
                        fill: url(#linear-gradient-27);
                    }
                    .cls-45 {
                        fill: url(#linear-gradient-28);
                    }
                    .cls-46 {
                        fill: url(#linear-gradient-29);
                    }
                    .cls-49 {
                        fill: url(#linear-gradient-30);
                    }
                    .cls-50 {
                        fill: #21389b;
                    }
                    .cls-51 {
                        fill: url(#linear-gradient-31);
                    }
                    .cls-52 {
                        fill: url(#linear-gradient-32);
                    }
                    .cls-54 {
                        fill: url(#linear-gradient-33);
                    }
                    .cls-55 {
                        fill: url(#linear-gradient-34);
                    }
                    .cls-56 {
                        fill: url(#linear-gradient-35);
                    }
                    .cls-57 {
                        fill: #ffd85e;
                    }
                    .cls-58 {
                        fill: url(#linear-gradient-36);
                    }
                    .cls-59 {
                        fill: #ff8978;
                    }
                    .cls-60 {
                        fill: url(#linear-gradient-37);
                    }
                    .cls-61 {
                        fill: #6266d7;
                    }
                    .cls-62 {
                        fill: url(#linear-gradient-38);
                    }
                    .cls-63 {
                        fill: url(#GradientFill_10);
                    }
                    .cls-64 {
                        fill: url(#linear-gradient-39);
                    }
                    .cls-65 {
                        fill: url(#GradientFill_10-2);
                    }
                    .cls-66 {
                        fill: url(#linear-gradient-40);
                    }
                    .cls-67 {
                        fill: url(#linear-gradient-41);
                    }
                    .cls-68 {
                        fill: url(#linear-gradient-42);
                    }
                    .cls-69 {
                        fill: url(#linear-gradient-43);
                    }
                    .cls-70 {
                        fill: url(#linear-gradient-44);
                    }
                    .cls-71 {
                        fill: url(#linear-gradient-45);
                    }
                    .cls-72 {
                        fill: url(#linear-gradient-46);
                    }
                    .cls-73 {
                        fill: url(#linear-gradient-47);
                    }
                    .cls-74 {
                        fill: url(#linear-gradient-48);
                    }
                    .cls-75 {
                        fill: url(#linear-gradient-49);
                    }
                    .cls-76 {
                        fill: url(#linear-gradient-50);
                    }
                    .cls-77 {
                        fill: url(#linear-gradient-51);
                    }
                `}
          </style>
          <linearGradient
            id="linear-gradient"
            x1="19.01"
            y1="629.87"
            x2="747.18"
            y2="629.87"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" stopColor="#7bca96"></stop>
            <stop offset="1" stopColor="#5eaada"></stop>
          </linearGradient>
          <linearGradient
            id="linear-gradient-2"
            x1="87.42"
            y1="629.87"
            x2="678.77"
            y2="629.87"
            xlinkHref="#linear-gradient"
          ></linearGradient>
          <linearGradient
            id="linear-gradient-3"
            x1="307.58"
            y1="608.56"
            x2="668.97"
            y2="608.56"
            xlinkHref="#linear-gradient"
          ></linearGradient>
          <linearGradient
            id="linear-gradient-4"
            x1="497.5"
            y1="222.72"
            x2="156.6"
            y2="506.93"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" stopColor="#6fbdb1"></stop>
            <stop offset="1" stopColor="#8ee068"></stop>
          </linearGradient>
          <linearGradient
            id="linear-gradient-5"
            x1="430.18"
            y1="567.55"
            x2="531.33"
            y2="93.97"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" stopColor="#00638e"></stop>
            <stop offset="1" stopColor="#62addd"></stop>
          </linearGradient>
          <linearGradient
            id="linear-gradient-6"
            x1="696.05"
            y1="78.98"
            x2="692.52"
            y2="9.92"
            gradientTransform="translate(583.86 -637.34) rotate(76.72)"
            xlinkHref="#linear-gradient-5"
          ></linearGradient>
          <linearGradient
            id="linear-gradient-7"
            x1="45.39"
            y1="382.41"
            x2="64.49"
            y2="425.65"
            xlinkHref="#linear-gradient-4"
          ></linearGradient>
          <linearGradient
            id="linear-gradient-8"
            x1="81.99"
            y1="108.46"
            x2="91.15"
            y2="91.81"
            xlinkHref="#linear-gradient-4"
          ></linearGradient>
          <linearGradient
            id="linear-gradient-9"
            x1="629.12"
            y1="227.77"
            x2="632.21"
            y2="240.53"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" stopColor="#ff8a78"></stop>
            <stop offset="1" stopColor="#ffa799"></stop>
          </linearGradient>
          <linearGradient
            id="linear-gradient-10"
            x1="616.96"
            y1="197.41"
            x2="625.12"
            y2="217.82"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" stopColor="#ffb89e"></stop>
            <stop offset="1" stopColor="#ffa799"></stop>
          </linearGradient>
          <linearGradient
            id="linear-gradient-11"
            x1="618.36"
            y1="171.78"
            x2="630.88"
            y2="186.53"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" stopColor="#5a2d68"></stop>
            <stop offset="1" stopColor="#22043d"></stop>
          </linearGradient>
          <linearGradient
            id="linear-gradient-12"
            x1="652.57"
            y1="286.22"
            x2="663.26"
            y2="321.27"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" stopColor="#94e69a"></stop>
            <stop offset="1" stopColor="#17adc9"></stop>
          </linearGradient>
          <linearGradient
            id="linear-gradient-13"
            x1="689.17"
            y1="622.85"
            x2="728.58"
            y2="622.85"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" stopColor="#005073"></stop>
            <stop offset="1" stopColor="#004461"></stop>
          </linearGradient>
          <linearGradient
            id="linear-gradient-14"
            x1="615.22"
            y1="399.9"
            x2="722.35"
            y2="550.53"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" stopColor="#235da3"></stop>
            <stop offset="1" stopColor="#123a76"></stop>
          </linearGradient>
          <linearGradient
            id="linear-gradient-15"
            x1="615.14"
            y1="401.54"
            x2="699.92"
            y2="553.89"
            xlinkHref="#linear-gradient-14"
          ></linearGradient>
          <linearGradient
            id="linear-gradient-16"
            x1="559.09"
            y1="620.56"
            x2="626.3"
            y2="620.56"
            xlinkHref="#linear-gradient-13"
          ></linearGradient>
          <linearGradient
            id="linear-gradient-17"
            x1="592.77"
            y1="411.02"
            x2="649.34"
            y2="547.82"
            xlinkHref="#linear-gradient-14"
          ></linearGradient>
          <linearGradient
            id="linear-gradient-18"
            x1="621.17"
            y1="280.3"
            x2="645.53"
            y2="367.51"
            xlinkHref="#linear-gradient-12"
          ></linearGradient>
          <linearGradient
            id="linear-gradient-19"
            x1="570.15"
            y1="412.09"
            x2="582.14"
            y2="415.21"
            xlinkHref="#linear-gradient-10"
          ></linearGradient>
          <linearGradient
            id="linear-gradient-20"
            x1="584.56"
            y1="418.35"
            x2="574.84"
            y2="417.15"
            xlinkHref="#linear-gradient-9"
          ></linearGradient>
          <linearGradient
            id="linear-gradient-21"
            x1="596.3"
            y1="283.52"
            x2="584.59"
            y2="382.37"
            xlinkHref="#linear-gradient-12"
          ></linearGradient>
          <linearGradient
            id="linear-gradient-22"
            x1="340.34"
            y1="341.15"
            x2="416.73"
            y2="158.76"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" stopColor="#965cf2"></stop>
            <stop offset="1" stopColor="#ff8adc"></stop>
          </linearGradient>
          <linearGradient
            id="linear-gradient-23"
            x1="255.24"
            y1="176.69"
            x2="257.87"
            y2="190.1"
            xlinkHref="#linear-gradient-5"
          ></linearGradient>
          <linearGradient
            id="linear-gradient-24"
            x1="281.88"
            y1="247.72"
            x2="376.32"
            y2="283.2"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" stopColor="#79c89a"></stop>
            <stop offset="0.56" stopColor="#4195c3"></stop>
            <stop offset="1" stopColor="#22d2fb"></stop>
          </linearGradient>
          <linearGradient
            id="linear-gradient-25"
            x1="312.94"
            y1="232.96"
            x2="322.2"
            y2="312.26"
            xlinkHref="#linear-gradient-4"
          ></linearGradient>
          <linearGradient
            id="linear-gradient-26"
            x1="508.75"
            y1="149.87"
            x2="554.3"
            y2="53.4"
            xlinkHref="#linear-gradient-22"
          ></linearGradient>
          <linearGradient
            id="linear-gradient-27"
            x1="522.81"
            y1="146.97"
            x2="500.04"
            y2="60.95"
            xlinkHref="#linear-gradient-4"
          ></linearGradient>
          <linearGradient
            id="linear-gradient-28"
            x1="379.39"
            y1="467.59"
            x2="468.61"
            y2="361.11"
            xlinkHref="#linear-gradient-22"
          ></linearGradient>
          <linearGradient
            id="linear-gradient-29"
            x1="389.11"
            y1="382.32"
            x2="386.79"
            y2="454.24"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" stopColor="#70beb0"></stop>
            <stop offset="1" stopColor="#5eaada"></stop>
          </linearGradient>
          <linearGradient
            id="linear-gradient-30"
            x1="268.11"
            y1="461.26"
            x2="280.57"
            y2="490.35"
            xlinkHref="#linear-gradient-29"
          ></linearGradient>
          <linearGradient
            id="linear-gradient-31"
            x1="397.45"
            y1="609.36"
            x2="465.58"
            y2="515.27"
            xlinkHref="#linear-gradient-22"
          ></linearGradient>
          <linearGradient
            id="linear-gradient-32"
            x1="358.8"
            y1="576.48"
            x2="489.86"
            y2="576.48"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" stopColor="#5eaada"></stop>
            <stop offset="1" stopColor="#6ebcb4"></stop>
          </linearGradient>
          <linearGradient
            id="linear-gradient-33"
            x1="399.7"
            y1="527.12"
            x2="448.95"
            y2="527.12"
            xlinkHref="#linear-gradient"
          ></linearGradient>
          <linearGradient
            id="linear-gradient-34"
            x1="422.94"
            y1="576.04"
            x2="425.61"
            y2="532.25"
            xlinkHref="#linear-gradient-12"
          ></linearGradient>
          <linearGradient
            id="linear-gradient-35"
            x1="424.81"
            y1="581.37"
            x2="424.94"
            y2="591.96"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" stopColor="#fdd248"></stop>
            <stop offset="1" stopColor="#fabd23"></stop>
          </linearGradient>
          <linearGradient
            id="linear-gradient-36"
            x1="304.71"
            y1="226.75"
            x2="310.85"
            y2="238.67"
            xlinkHref="#linear-gradient-10"
          ></linearGradient>
          <linearGradient
            id="linear-gradient-37"
            x1="226.9"
            y1="232.36"
            x2="252.85"
            y2="299.08"
            xlinkHref="#linear-gradient-32"
          ></linearGradient>
          <linearGradient
            id="linear-gradient-38"
            x1="72.4"
            y1="619.07"
            x2="109.1"
            y2="619.07"
            xlinkHref="#linear-gradient-13"
          ></linearGradient>
          <linearGradient
            id="GradientFill_10"
            x1="97.98"
            y1="615.01"
            x2="91.69"
            y2="600.8"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" stopColor="#002041"></stop>
            <stop offset="1" stopColor="#004975"></stop>
          </linearGradient>
          <linearGradient
            id="linear-gradient-39"
            x1="173.63"
            y1="612.89"
            x2="240.15"
            y2="612.89"
            xlinkHref="#linear-gradient-13"
          ></linearGradient>
          <linearGradient
            id="GradientFill_10-2"
            x1="191.33"
            y1="606.28"
            x2="184.73"
            y2="595.1"
            xlinkHref="#GradientFill_10"
          ></linearGradient>
          <linearGradient
            id="linear-gradient-40"
            x1="205.18"
            y1="405.01"
            x2="152.17"
            y2="541.79"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" stopColor="#2a83b0"></stop>
            <stop offset="1" stopColor="#00577d"></stop>
          </linearGradient>
          <linearGradient
            id="linear-gradient-41"
            x1="184.6"
            y1="394.48"
            x2="78.57"
            y2="543.57"
            xlinkHref="#linear-gradient-40"
          ></linearGradient>
          <linearGradient
            id="linear-gradient-42"
            x1="154.42"
            y1="256.74"
            x2="179.7"
            y2="365.69"
            xlinkHref="#linear-gradient-32"
          ></linearGradient>
          <linearGradient
            id="linear-gradient-43"
            x1="161.5"
            y1="223.48"
            x2="159.71"
            y2="229.86"
            xlinkHref="#linear-gradient-9"
          ></linearGradient>
          <linearGradient
            id="linear-gradient-44"
            x1="158.49"
            y1="165.98"
            x2="160.03"
            y2="184.28"
            xlinkHref="#linear-gradient-11"
          ></linearGradient>
          <linearGradient
            id="linear-gradient-45"
            x1="164.36"
            y1="191.88"
            x2="156.89"
            y2="213.11"
            xlinkHref="#linear-gradient-10"
          ></linearGradient>
          <linearGradient
            id="linear-gradient-46"
            x1="155.11"
            y1="255.76"
            x2="184.68"
            y2="317.53"
            xlinkHref="#linear-gradient-40"
          ></linearGradient>
          <linearGradient
            id="linear-gradient-47"
            x1="143.93"
            y1="239.9"
            x2="165.81"
            y2="239.9"
            xlinkHref="#linear-gradient-40"
          ></linearGradient>
          <linearGradient
            id="linear-gradient-48"
            x1="165.5"
            y1="239.42"
            x2="178.6"
            y2="239.42"
            xlinkHref="#linear-gradient-40"
          ></linearGradient>
          <linearGradient
            id="linear-gradient-49"
            x1="173.38"
            y1="345.18"
            x2="167.44"
            y2="359.3"
            xlinkHref="#linear-gradient-10"
          ></linearGradient>
          <linearGradient
            id="linear-gradient-50"
            x1="166.27"
            y1="361.76"
            x2="170.46"
            y2="354.21"
            xlinkHref="#linear-gradient-9"
          ></linearGradient>
          <linearGradient
            id="linear-gradient-51"
            x1="144.23"
            y1="290.61"
            x2="109.66"
            y2="330.07"
            xlinkHref="#linear-gradient-32"
          ></linearGradient>
        </defs>
        <title>Artboard 25</title>
        <g className="cls-1">
          <g id="Layer_1" data-name="Layer 1">
            <path
              className="cls-2"
              d="M383.1,611.41c201.07,0,364.08,8.26,364.08,18.46s-163,18.46-364.08,18.46S19,640.06,19,629.87,182,611.41,383.1,611.41Z"
            ></path>
            <path
              className="cls-3"
              d="M383.1,620.09c163.29,0,295.67,4.38,295.67,9.78s-132.38,9.77-295.67,9.77-295.68-4.38-295.68-9.77S219.8,620.09,383.1,620.09Z"
            ></path>
            <ellipse
              className="cls-4"
              cx="488.27"
              cy="608.56"
              rx="180.69"
              ry="9.77"
            ></ellipse>
            <path
              className="cls-5"
              d="M80.23,40h606.3c37.4,0,68,30,68,66.72V529c0,36.7-30.6,66.72-68,66.72H80.23c-37.41,0-68-30-68-66.72V106.69C12.22,70,42.82,40,80.23,40Z"
            ></path>
            <rect
              className="cls-6"
              x="332.81"
              y="99.61"
              width="285.22"
              height="512.21"
              rx="29.12"
            ></rect>
            <rect
              className="cls-7"
              x="344.76"
              y="112.29"
              width="261.33"
              height="486.83"
              rx="26.68"
            ></rect>
            <path
              className="cls-8"
              d="M475.43,197.72a30.61,30.61,0,1,1-30.61,30.6,30.6,30.6,0,0,1,30.61-30.6Zm0,7.92a22.68,22.68,0,1,0,22.68,22.68A22.68,22.68,0,0,0,475.43,205.64Z"
            ></path>
            <path
              className="cls-8"
              d="M449.53,268.15h51.79a2.44,2.44,0,0,1,2.23,2.59v4.48a2.45,2.45,0,0,1-2.23,2.6H449.53a2.45,2.45,0,0,1-2.23-2.6v-4.48A2.44,2.44,0,0,1,449.53,268.15Z"
            ></path>
            <rect
              className="cls-9"
              x="424.92"
              y="288.07"
              width="101.01"
              height="9.66"
              rx="2.59"
            ></rect>
            <circle
              className="cls-10"
              cx="694.58"
              cy="50.2"
              r="39.7"
              transform="translate(486.14 714.67) rotate(-76.72)"
            ></circle>
            <path
              className="cls-11"
              d="M57.73,374.07a36.27,36.27,0,1,1-36.27,36.27A36.27,36.27,0,0,1,57.73,374.07Z"
            ></path>
            <path
              className="cls-12"
              d="M85.89,79.39a22,22,0,1,1-22,22A22,22,0,0,1,85.89,79.39Z"
            ></path>
            <path
              className="cls-13"
              d="M617.4,223.53c.94,5.67,2.61,11.23-.82,18.77l32.17.21c-10.86-10.15-11.56-16.23-11.43-25.77l-12,2.42Z"
            ></path>
            <path
              className="cls-14"
              d="M608.24,185.24c-5,6.51-8.38,21.32-6.72,32.63.56,3.82,1.08,8.59,3.71,10,2.86,1.54,7.24.87,13.89.12,9.64-1.1,8.56-3.4,13.58-12.31L641,195.09,623.75,178Z"
            ></path>
            <path
              className="cls-15"
              d="M608.24,185.24a22.47,22.47,0,0,0-2.17,3.53c2.69,1.62,4.39,2,9.73,1.52.36,5.31,3,18.66,9.38,17.07,1.14-.29,2.44-1.82,3.66-2.61,1.49-1,3.52-.47,2.64,2.39-2.4,7.76-4.51,9.21-1.91,14.54.81-1.57,1.74-3.53,3.13-6L641,195.09,623.75,178Z"
            ></path>
            <path
              className="cls-16"
              d="M617.51,188.18C602.24,190,600,180.28,603.58,173c4.42-9,17.88-15.15,26.76-.84,6.54-3.23,9.07-2.57,12,4.76,11.91-2.74,16.17,7.92,13.34,18-2.58,9.18-9.44,15.06-15,22.2a43.32,43.32,0,0,0-4.43,6.84c-3.7-1.15-4.53-2.63-5.12-5.3-.42-1.86,1.67-8.15,2.09-12.26.31-3-1.73-5.45-5-3.39-1,.61-1.55,2.11-3,3.46C618,202.16,618.61,195.88,617.51,188.18Z"
            ></path>
            <path
              className="cls-17"
              d="M617.51,188.18C602.24,190,600,180.28,603.58,173l.18-.36c.55,6.26,4.24,9.95,10.51,9.73,7.06-.24,9.13.31,10.36,9.16.64,4.67,1.06,7.62,4,6.86,6.29-1.63,9.81,1.14,9.86,8.76,0,3.77,1.44,6.57,4.15,7.56-.65.78-1.29,1.57-1.91,2.38a15.42,15.42,0,0,0-3.07,7.64c-10.9-3.4-5.17-10.69-4.39-18.36.31-3-1.73-5.45-5-3.39-1,.61-1.55,2.11-3,3.46C618,202.16,618.61,195.88,617.51,188.18Z"
            ></path>
            <path
              className="cls-18"
              d="M672.39,245c5.83,5.37,11.78,10.48,15.92,15.84,34.84,45.08,9,86.7-71.15,70.67C626.11,275.4,636.43,288.68,672.39,245Z"
            ></path>
            <path
              className="cls-19"
              d="M703.26,294.18c2.86,29.39-26.71,49.18-86.1,37.3,6.86-43,14.52-45.22,33.9-63.59l23,10.29c1.91,13.79,3.87,27,5.24,40.89C692.9,313.33,700,307.31,703.26,294.18Z"
            ></path>
            <path
              className="cls-20"
              d="M727.76,635.91l-37,.59c-1.84-2-2.34-9.08-.4-12.1a26.93,26.93,0,0,0,4.56-13l13.9.63,6-2.81c2.69,3.53,8.39,10,12.41,15.76C729.25,627.8,728.63,632.91,727.76,635.91Z"
            ></path>
            <path
              className="cls-21"
              d="M693.58,619.9a41.68,41.68,0,0,0,1.39-8.51l13.9.63,6-2.81c1.06,1.39,2.59,3.24,4.29,5.32C713.72,620.32,697.12,623.56,693.58,619.9Z"
            ></path>
            <path
              className="cls-22"
              d="M667.91,369.35c3.39,10.26,7.85,18,12.52,39,5.08,22.82,6.53,44.33,10.34,66.52a1367.5,1367.5,0,0,0,29.81,134.6c-7.52,6.26-22.23,6.27-27.61,4.36-16.06-36.53-25.94-72.18-40.08-109.22C633.51,453.87,612.38,403,595.6,354.81Z"
            ></path>
            <path
              className="cls-23"
              d="M637.15,368.65c7.59,23,50.25,188.73,55.82,245.2-16.06-36.53-25.94-72.18-40.08-109.22C633.51,453.87,612.38,403,595.6,354.81Z"
            ></path>
            <path
              className="cls-24"
              d="M621,606.21c1.14,5.66,4.59,10,5.13,14.14.94,7.17-3.19,14.36-11.66,14.44l-55.42.49c2.94-18.93,32.56-8.44,42.51-29.43l12.9.73Z"
            ></path>
            <path
              className="cls-21"
              d="M621,606.21a26.42,26.42,0,0,0,1.67,5.16c-5.19,3.6-15.21,6-26.81,2a22.7,22.7,0,0,0,5.7-7.57l12.9.73Z"
            ></path>
            <path
              className="cls-25"
              d="M583.07,364.62c-2.26,13.58-3,26.52-2.81,43.41C581,471.5,591.17,543.36,598,606.76c9,3.47,19,3.29,26.52.19,1.1-36.71,1.73-75.74,5.5-111.86,6.25-60,30.88-102.06,16.48-137.37l-42.87-1.46Z"
            ></path>
            <path
              className="cls-26"
              d="M682.36,258.15c12.9,21.31-7.06,18.26-9,33.41-3.7,34.56-5.42,58.23.9,93.56-39.17,14.19-71.21,8.9-92.66.22,4.27-27.13-.59-93.4,6.34-118.57,4-14.66-14-18.19-2.91-22.48C605.32,236.42,634,230,655,236.22c6.71,2,12.2,4.07,17.57,9.08A61,61,0,0,1,682.36,258.15Z"
            ></path>
            <path
              className="cls-19"
              d="M620.1,393.75a118.2,118.2,0,0,1-38.46-8.41c4.27-27.13-.59-93.41,6.34-118.57,4-14.66-12.83-15.83-1.78-20.12,6.29-2.44,20.48,4.23,23.77,11.65C631.73,307.38,630,349.08,620.1,393.75Z"
            ></path>
            <path
              className="cls-27"
              d="M535,410.07l20.09-42.79a3.78,3.78,0,0,1,5-1.81l67.1,31.69a3.78,3.78,0,0,1,1.81,5L608.91,445a3.79,3.79,0,0,1-5,1.82l-67.1-31.69A3.79,3.79,0,0,1,535,410.07Z"
            ></path>
            <path
              className="cls-28"
              d="M586,377.57l19.36,9.14c-4.76,7.79-9.07,14.92-12.55,23.43,0,6.19-1.79,12.8-13.38,24.95l-12.23-5.77,7.91-10.52Z"
            ></path>
            <path
              className="cls-29"
              d="M563.9,429.35c5.32,2.68,8.14,4.06,9.49,3.67,3.44-1,9.54-10.35,12.27-15.55,2.42-4.62-1.41-10.12.56-13.28-2.81-4.67-8.64-11.57-13.47-11.65-1.13,11.54-15.47,23.47-17.7,29.88C553.71,426.3,561.14,428,563.9,429.35Z"
            ></path>
            <path
              className="cls-30"
              d="M568.08,431.42c2.71,1.28,4.37,1.87,5.31,1.59,3.44-1,9.54-10.34,12.27-15.54,2.42-4.62-1.41-10.12.56-13.28-2.81-4.67,0,.33-4.8.25C581.94,415.18,575.07,421.71,568.08,431.42Z"
            ></path>
            <path
              className="cls-31"
              d="M614.57,295.44c1.67,15.86,2.23,31.9.2,44-3.52,21-11,40.88-27,67.09-9.81,2.42-18.32-4.15-17.3-11.39,6.37-13.22,13.56-49.73,13.63-58.76.12-18.1-2.94-34.87-8.61-61-4.46-20.27.74-28.55,10.37-31.51C611.52,236,612.74,278,614.57,295.44Z"
            ></path>
            <path
              className="cls-32"
              d="M332.81,155.42h83.78A12.59,12.59,0,0,1,429.15,168V330.29a12.59,12.59,0,0,1-12.56,12.56H332.81Z"
            ></path>
            <rect
              className="cls-33"
              x="231.85"
              y="155.42"
              width="180.42"
              height="171.4"
              rx="11.48"
            ></rect>
            <path
              className="cls-34"
              d="M256.46,166.9a16,16,0,1,1-16,16A16,16,0,0,1,256.46,166.9Z"
            ></path>
            <path
              className="cls-35"
              d="M256.46,174.28a8.61,8.61,0,1,1-8.61,8.61A8.62,8.62,0,0,1,256.46,174.28Z"
            ></path>
            <rect
              className="cls-36"
              x="279.11"
              y="170.69"
              width="51.88"
              height="9.02"
              rx="2.97"
            ></rect>
            <rect
              className="cls-36"
              x="279.11"
              y="186.07"
              width="89.08"
              height="9.02"
              rx="2.97"
            ></rect>
            <rect
              className="cls-37"
              x="241.13"
              y="207.63"
              width="161.86"
              height="110.38"
              rx="10.3"
            ></rect>
            <polygon
              className="cls-38"
              points="287.41 222.46 333.75 284.38 362.39 259.79 396.49 311.03 247.64 311.03 287.41 222.46"
            ></polygon>
            <path
              className="cls-39"
              d="M339.08,222.46a10.25,10.25,0,1,1-10.25,10.25A10.25,10.25,0,0,1,339.08,222.46Z"
            ></path>
            <path
              className="cls-40"
              d="M563.53,175.11l-98.3-.38a6.64,6.64,0,0,1-6.32-5.73l-2.07-17-6.33-52,101.09.45,37.84-.93,7.92,1.28L582.9,163.33C581.25,172.75,579.25,175.18,563.53,175.11Z"
            ></path>
            <path
              className="cls-41"
              d="M495.08,74.48h93.24a4.52,4.52,0,0,1,4.51,5.81L575.39,158a7.71,7.71,0,0,1-7.12,5.81H475a4.52,4.52,0,0,1-4.51-5.81L488,80.29A7.71,7.71,0,0,1,495.08,74.48Z"
            ></path>
            <rect
              className="cls-42"
              x="469.85"
              y="53.98"
              width="109.21"
              height="107.6"
              rx="9.93"
            ></rect>
            <rect
              className="cls-43"
              x="476.14"
              y="63.45"
              width="96.64"
              height="10.59"
              rx="2.5"
            ></rect>
            <rect
              className="cls-43"
              x="476.14"
              y="86.15"
              width="96.64"
              height="7.12"
              rx="1.68"
            ></rect>
            <rect
              className="cls-43"
              x="476.14"
              y="104.47"
              width="96.64"
              height="7.12"
              rx="1.68"
            ></rect>
            <rect
              className="cls-43"
              x="476.14"
              y="122.78"
              width="96.64"
              height="7.12"
              rx="1.68"
            ></rect>
            <path
              className="cls-44"
              d="M529.12,83.72h29.8a6.08,6.08,0,0,1,5.85,5.21l8.67,69.69a4.52,4.52,0,0,1-4.57,5.21H474.43a6.09,6.09,0,0,1-5.86-5.21l-1.92-15.45-6.74-54.24-1.19-9.59a7.05,7.05,0,0,1,7.13-8.14h39.34c4.48,0,6.71,1.63,9.63,5.37C519.8,83,520.81,83.72,529.12,83.72Z"
            ></path>
            <path
              className="cls-45"
              d="M514.55,392.82v60.25c0,14.55-11.19,26.49-24.84,26.49H332.81V366.33h156.9C503.38,366.33,514.55,378.25,514.55,392.82Z"
            ></path>
            <path
              className="cls-46"
              d="M499.93,389.65v53A23.39,23.39,0,0,1,476.62,466H299.41a23.39,23.39,0,0,1-23.31-23.31v-53a23.38,23.38,0,0,1,23.31-23.32H476.62A23.38,23.38,0,0,1,499.93,389.65Z"
            ></path>
            <path
              className="cls-47"
              d="M353.05,398.7H487.83a3.92,3.92,0,0,1,3.74,4.05v9a3.93,3.93,0,0,1-3.74,4.05H353.05a3.93,3.93,0,0,1-3.74-4.05v-9A3.91,3.91,0,0,1,353.05,398.7Z"
            ></path>
            <rect
              className="cls-48"
              x="349.31"
              y="424.28"
              width="117.06"
              height="9.33"
              rx="2.2"
            ></rect>
            <path
              className="cls-47"
              d="M313.82,392a24.21,24.21,0,1,1-24.2,24.21A24.21,24.21,0,0,1,313.82,392Z"
            ></path>
            <path
              className="cls-8"
              d="M313.82,400.73a15.43,15.43,0,1,1-15.43,15.43,15.43,15.43,0,0,1,15.43-15.43Zm0,6.1a9.33,9.33,0,1,0,9.32,9.33A9.33,9.33,0,0,0,313.82,406.83Z"
            ></path>
            <path
              className="cls-8"
              d="M274.31,440.63a36,36,0,1,1-36,36A36,36,0,0,1,274.31,440.63Z"
            ></path>
            <path
              className="cls-49"
              d="M274.31,463.67a18.78,18.78,0,0,1,8.71,2.12v-5.45a1.23,1.23,0,0,0-1.22-1.22h-15a1.23,1.23,0,0,0-1.22,1.22v5.45a18.79,18.79,0,0,1,8.72-2.12Zm16.26,9.19a19,19,0,1,1-32.53,0V460.34a8.79,8.79,0,0,1,8.77-8.78h15a8.79,8.79,0,0,1,8.77,8.78Z"
            ></path>
            <path
              className="cls-50"
              d="M274.31,478.49a3.83,3.83,0,0,1,2.37,6.84v7a2.38,2.38,0,0,1-2.37,2.37h0a2.38,2.38,0,0,1-2.37-2.37v-7a3.83,3.83,0,0,1,2.38-6.84Z"
            ></path>
            <path
              className="cls-51"
              d="M390,515.68a17,17,0,0,1,16.5-13H442.2a17,17,0,0,1,16.49,13h16.25a25.16,25.16,0,0,1,25.11,25.11v71H361.93a28.76,28.76,0,0,1-13.32-3.25V540.79a25.15,25.15,0,0,1,25.11-25.11Z"
            ></path>
            <rect
              className="cls-52"
              x="358.8"
              y="525.87"
              width="131.06"
              height="101.22"
              rx="14.92"
            ></rect>
            <path
              className="cls-53"
              d="M373.72,532.39H474.94a14.94,14.94,0,0,1,14.92,14.86v25.31L451,593.93H436.39v2.86a3.71,3.71,0,0,1-3.58,3.79H417a3.7,3.7,0,0,1-3.58-3.79v-2.86h-15.7L358.8,572.56V547.25A14.93,14.93,0,0,1,373.72,532.39Z"
            ></path>
            <path
              className="cls-54"
              d="M406.46,512.82H442.2a6.77,6.77,0,0,1,6.75,6.75v11.51c-25,13.79-24.25,13.79-49.25,0V519.57a6.78,6.78,0,0,1,6.76-6.75Zm5.3,6.52a5.05,5.05,0,0,0-5.18,4.88v8.31c19.11,9.91,16.39,9.91,35.5,0v-8.31a5.06,5.06,0,0,0-5.19-4.88Z"
            ></path>
            <path
              className="cls-53"
              d="M449,522.17v8.91c-25,13.79-24.25,13.79-49.25,0v-8.91h7.36a4.58,4.58,0,0,0-.48,2.05v8.31c19.11,9.91,16.39,9.91,35.5,0v-8.31a4.59,4.59,0,0,0-.49-2.05Z"
            ></path>
            <path
              className="cls-55"
              d="M373.72,525.87H474.94a15,15,0,0,1,14.92,14.92v25.42L451,587.67H397.69L358.8,566.21V540.79A15,15,0,0,1,373.72,525.87Z"
            ></path>
            <rect
              className="cls-56"
              x="416.12"
              y="579.27"
              width="17.54"
              height="16.56"
              rx="2.73"
            ></rect>
            <path
              className="cls-57"
              d="M419.35,580h11.08a2.51,2.51,0,0,1,2.5,2.5v10.19C430.4,584.58,427,582.75,419.35,580Z"
            ></path>
            <path
              className="cls-58"
              d="M285.09,237.29c.53-7.17,2.73-7.62,12.06-13.61,2-1.25,3.8-2.93,8.09-7.87,3,2.47.75,5.1-1.29,8.74a24.83,24.83,0,0,0-2.46,6c8.41-.5,11.25-2.08,13.22-4.29,9.81-10.95,11.59-13,24.51-12.93-6,7.84-10.58,12.89-13.74,21.12-1.93,5.06-1.53,4.66-5,6.26-4.74,2.17-8.76,4.43-13.23,6.61-9.94,4.86-9.68,7.34-16.13,16.46l-12.3-7C283.14,247.59,284.33,247.5,285.09,237.29Z"
            ></path>
            <path
              className="cls-59"
              d="M290.61,244.74c4.73-11.2,8.73-11.92,22.75-16l7.75,4.68-6.6-2.5C304.86,235.56,295.53,235,290.61,244.74Z"
            ></path>
            <path
              className="cls-60"
              d="M188.29,231.84c28.09,9.08,36.79,49.11,51.64,48.47,13.06-.55,24.9-11.42,41.8-35.74,4.29-.17,12.27,5.3,15.73,12.12-11.93,20.86-29,58.93-55.91,59.83C227.61,317,206,305.86,193,289,171,260.36,177.62,260.81,188.29,231.84Z"
            ></path>
            <path
              className="cls-61"
              d="M193.08,259.34c17.67,32.1,32.6,45.59,47.21,48.3,7.64,1.42,22.12-4.1,40.76-22.18-10.19,16-23,30.51-39.5,31.06C227.61,317,206,305.86,193,289Z"
            ></path>
            <path
              className="cls-62"
              d="M73.21,628.08c6.5,5.69,8.7,8.06,17.09,8.39,6.84.28,9.17-1.49,13.1-4.65,4.35-3.5,5.72-5.7,5.7-8.87-.06-6.05-3.09-11.56-3.43-19.15l-13.76.63L86,601.64c-2.66,3.5-8.3,9.94-12.28,15.61C71.74,620.05,72.36,625.11,73.21,628.08Z"
            ></path>
            <path
              className="cls-63"
              d="M107.05,612.23a40.78,40.78,0,0,1-1.38-8.43l-13.76.63L86,601.64c-1,1.38-2.56,3.21-4.24,5.27C87.11,612.64,103.55,615.85,107.05,612.23Z"
            ></path>
            <path
              className="cls-64"
              d="M178.84,598.68c-1.12,5.6-4.54,9.88-5.08,14-.93,7.09,3.16,14.21,11.54,14.28l54.85.49c-2.9-18.74-32.22-8.35-42.07-29.13l-12.76.72Z"
            ></path>
            <path
              className="cls-65"
              d="M178.84,598.68a25.17,25.17,0,0,1-1.65,5.1c5.14,3.57,15.05,6,26.53,2a22.6,22.6,0,0,1-5.64-7.5l-12.76.72Z"
            ></path>
            <path
              className="cls-66"
              d="M216.42,359.56c2.24,13.44,3,26.25,2.79,43-.7,62.81-10.81,133.94-17.53,196.7-9,3.43-18.8,3.25-26.25.18-1.09-36.34-1.47-73.78-3.37-109.68-2.38-45.22-8.08-80.6-18.39-137l42.44-1.44Z"
            ></path>
            <path
              className="cls-21"
              d="M189.46,359.56c2.24,13.44,2.25,52.14,2.06,68.86-.62,56-9.2,115.55-16.09,171-1.09-36.34-1.47-73.78-3.37-109.68-2.09-39.6-6.72-71.66-14.76-116.9Z"
            ></path>
            <path
              className="cls-67"
              d="M132.46,364.24c-3.36,10.16-7.78,17.84-12.4,38.62-5,22.59-6.46,43.88-10.23,65.84A1352.2,1352.2,0,0,1,80.32,601.93c7.44,6.19,22,6.2,27.33,4.31,15.89-36.16,25.67-71.44,39.67-108.1,19.18-50.24,40.1-100.56,56.7-148.28Z"
            ></path>
            <path
              className="cls-68"
              d="M129.27,280.84c-.26,27.28,1.39,64.61-.18,91.28,29.67,6.35,61.48,8.69,90.16-1.08-.36-17.7-4.5-44.09-8.72-68.52-2.89-16.74.28-32.6-3.11-47.41C204.42,242,197.15,234,186.64,231a76.42,76.42,0,0,0-24.2-2.76C144,229,123.18,234,110,250,93.4,268.4,113.19,296.13,129.27,280.84Z"
            ></path>
            <path
              className="cls-15"
              d="M149.94,215.43A111.09,111.09,0,0,1,148.32,231c2.44,8.55,10.42,14.16,18.35,13.09,6.84-.93,8.62-10.17,6.29-15.88a77.25,77.25,0,0,1-.54-7.91l-17.26-5Z"
            ></path>
            <path
              className="cls-69"
              d="M149.94,215.43c-.08,1.64-.4,6.33-.5,7.82,5,10.48,19,12.69,23.82,7.56-.34-2.77-.77-7.73-.84-10.53l-17.26-5Z"
            ></path>
            <path
              className="cls-70"
              d="M147.24,208.74c-4.43.83-5.56-.66-6.59-3.62s-1-2.21-2.86-4.55a12.31,12.31,0,0,1-1.94-3.37c-1.43-3.75-.61-6-.67-8.92-.07-3.59-1.63-4.95-2.27-7.27-3.1-11.24,6.57-21,17.12-15.88,3.81-6.85,9.86-7,15.37-3.82,6.43-3.89,12.61-3.46,17,1.55,8.47,9.7.54,19.36-5.28,22L158.57,198Z"
            ></path>
            <path
              className="cls-17"
              d="M147.24,208.74c-4.43.83-5.56-.66-6.59-3.62s-1-2.21-2.86-4.55a12.31,12.31,0,0,1-1.94-3.37c-1.43-3.75-.61-6-.67-8.92v-.11c2.75,4.72,8.59,5.64,9.15-1a12.81,12.81,0,0,0,5.18-8.47c.51-4.21,2.29-6.54,7-5.21,10.92,3.1,19.86,8.81,29.46-.29-.69,5.51-5.21,10-8.89,11.62L158.57,198Z"
            ></path>
            <path
              className="cls-71"
              d="M179.28,183.52c.81,11.46,2.63,23.2-1.82,34.11-1.62,4-4.19,6.42-10.37,5.09-4.28-.91-8.74-2.87-12.71-4.48-6-2.45-5.15-4.86-6.16-7a14.06,14.06,0,0,0-2-2.86c-2.37-2.78-6.34-4.47-6.49-8.41-.14-3.62,2.6-5.56,4-3.08,1.95,3.47,6.39,9.33,3-9,3.66-2.77,4.36-3.86,5.32-6.85s2-5.22,5.45-3.36C164.72,181.58,170.91,185.29,179.28,183.52Z"
            ></path>
            <path
              className="cls-15"
              d="M179.28,183.52c.08,1.12.17,2.24.26,3.36-11.13,1.91-16.7-3-23.8-7.5-2.56,4.37-3.21,5.64-6.84,9.17.1,1.27,1.42,8.32.52,11.78-.73,2.82-2.24,2.41-3.87.7-1.09-1.15-3.49-6.3-5.54-3,.69-2.22,2.64-3,3.74-1.06,1.95,3.47,6.39,9.33,3-9,3.66-2.77,4.36-3.86,5.32-6.85s2-5.22,5.45-3.36C164.72,181.58,170.91,185.29,179.28,183.52Z"
            ></path>
            <path
              className="cls-72"
              d="M165,254.27l3,70.84,12.45,15.69,8.15-18.89-18.95-69c1.95-5.79,1.31-7.11.19-8-1.31-1,0-1.12-4.4-.59-2.88.35-5.82.64-5.39,3.75C160.41,250.52,162.48,252.25,165,254.27Z"
            ></path>
            <path
              className="cls-73"
              d="M148.86,227.05c-2.48.83-4.33,1.66-4.77,3.26-1.5,5.49,8,21,14.17,22.45a21.53,21.53,0,0,1,7.55-8.63C155.58,241.12,150,236.1,148.86,227.05Z"
            ></path>
            <path
              className="cls-74"
              d="M173,227.77a7.24,7.24,0,0,1,3.8,1c2.62,2.91,2.74,15.26-1.45,22.28a33.43,33.43,0,0,0-9.8-6.87C174.65,238.74,173.86,233.42,173,227.77Z"
            ></path>
            <path
              className="cls-27"
              d="M192.82,295.92l-49.38-9.54a4,4,0,0,0-4.71,3.19l-14.8,77.54a4,4,0,0,0,3.19,4.71l49.38,9.54a4,4,0,0,0,4.71-3.19L196,300.62A4,4,0,0,0,192.82,295.92Z"
            ></path>
            <path
              className="cls-28"
              d="M129.23,339.33,125,361.71c9.69.78,18.52,1.55,28,3.88,5.29,3.92,12.12,6.49,29.84,4.13l2.7-14.12-14,.2Z"
            ></path>
            <path
              className="cls-75"
              d="M187.64,352.74c-1,6.25-1.61,9.54-2.8,10.46-3,2.33-14.87,1.71-21.06.8-5.48-.8-7.81-7.55-11.76-7.83-2.26-5.35,3-12,5.92-16.2,8.2,3.09,22.37-1.29,29.28.82C191.4,342.06,188.18,349.49,187.64,352.74Z"
            ></path>
            <path
              className="cls-76"
              d="M186.8,357.63c-.6,3.14-1.13,4.93-2,5.57-3,2.33-14.87,1.71-21.06.8-5.48-.8-7.81-7.55-11.76-7.83-2.26-5.35.26.23,3.22-4C164.15,359.37,174.07,357.55,186.8,357.63Z"
            ></path>
            <path
              className="cls-77"
              d="M132.31,280.79c-10.1,13-21.31,22.41-18.92,30.1,3.87,12.39,21,19.15,48.63,29.17,1.26,4.08-1.79,14-7.46,19-23.07-6.13-64-12.81-71.73-38.43-2.36-7.83-2.22-18.9.94-30.1,5.67-20.05,27.55-47.51,46.55-55.12C137.7,232.5,139.74,271.24,132.31,280.79Z"
            ></path>
            <path
              className="cls-61"
              d="M153.48,336.94q4.08,1.51,8.54,3.12c1.26,4.08-1.79,14-7.46,19-23.07-6.13-64-12.81-71.73-38.43C96.19,342.61,143.09,354.43,153.48,336.94Z"
            ></path>
          </g>
        </g>
      </svg>
    </div>
  );
};
